"use client"
import React, { useEffect, useState } from "react";
import Dropdown from "@/components/ui/Dropdown";
import Icon from "@/components/ui/Icon";
import { Menu, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout } from "@/components/partials/auth/store";
import { useRouter } from "next/navigation";
import useAuthInfo from "@/store/auth";
import useDarkmode from "@/hooks/useDarkMode";

const ProfileLabel = () => {
  const userData = useAuthInfo((state) => state);

  return (
    <div className="flex items-center">
      <div className="flex-1 ">
        <div className="lg:h-8 lg:w-8 h-7 w-7 rounded-full flex items-center">
          {userData.imageUrl && (
            <img
              src={userData.imageUrl}
              alt=""
              className="block w-full h-full object-cover rounded-full"
            />
          )}
          {!userData.imageUrl && (
            <Icon
              className={"block  object-cover rounded-full"}
              icon="heroicons-outline:user"
              height={24}
              width={24}
            ></Icon>
          )}
        </div>
      </div>
      <div className="flex-none text-slate-600 dark:text-white text-sm font-normal items-center lg:flex hidden overflow-hidden text-ellipsis whitespace-nowrap">
        <span className="overflow-hidden text-ellipsis whitespace-nowrap w-[100px] block">
          {userData.fullName}
        </span>
        <span className="text-base inline-block ltr:ml-[10px] rtl:mr-[10px]">
          <Icon icon="heroicons-outline:chevron-down"></Icon>
        </span>
      </div>
      <div className="flex-none text-slate-600 dark:text-white text-sm font-normal items-center lg:hidden">
        <span className="overflow-hidden text-ellipsis whitespace-nowrap w-[100px] block">
          {userData.fullName}
        </span>
      </div>
    </div>
  );
};

const Profile = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const userData = useAuthInfo((state) => state);
  const logOut = useAuthInfo((state) => state.logout);
  const [isDark, setDarkMode] = useDarkmode();

  const [ProfileMenu, setProfileMenu] = useState([
    {
      label: "Portfolio",
      icon: "heroicons-outline:folder",
      action: () => {
        setDarkMode(false);
        router.push("/portfolio");
      },
    },
    {
      label: "Manage your listing",
      icon: "heroicons-outline:office-building",
      action: () => {
        setDarkMode(false);
        router.push("/discover/manage");
      },
    },
    {
      label: "Logout",
      icon: "heroicons-outline:login",
      action: () => {
        setDarkMode(false);
        logOut();
      },
    },
  ])


  useEffect(() => {
    if(userData.companies.some(x=>x.roleId ==1)){
      //append Dashboard to the ProfileMenu list
        setProfileMenu(prevMenu => [
          {
            label: "Home",
            icon: "heroicons-outline:home", // Choose an appropriate icon
            action: () => {
              setDarkMode(false);
              router.push("/");
            },
          },
          {
            label: "Dashboard",
            icon: "heroicons-outline:home", // Choose an appropriate icon
            action: () => {
              router.push("/discovery-stats");
            },
          },...prevMenu
        ]);
    }
  }, [])
  

  

  return (
    <div className="relative">
      <Dropdown key={ProfileMenu.length} label={ProfileLabel()} classMenuItems="w-[230px] top-[58px]">
        {ProfileMenu.map((item, index) => (
          <Menu.Item key={index}>
            {({ active }) => (
              <div
                onClick={() => item.action()}
                className={`${
                  active
                    ? "bg-slate-100 text-slate-900 dark:bg-slate-600 dark:text-slate-300 dark:bg-opacity-50"
                    : "text-slate-600 dark:text-slate-300"
                } block ${
                  item.hasDivider
                    ? "border-t border-slate-100 dark:border-slate-700"
                    : ""
                }`}
              >
                <div className={`block cursor-pointer px-4 py-2`}>
                  <div className="flex items-center">
                    <span className="block text-xl ltr:mr-3 rtl:ml-3">
                      <Icon icon={item.icon} />
                    </span>
                    <span className="block text-sm">{item.label}</span>
                  </div>
                </div>
              </div>
            )}
          </Menu.Item>
        ))}
      </Dropdown>
    </div>
  );
};

export default Profile;
